<template>
    <div class="container">
        <div class="search hunting-search">
            <el-form :inline="true" :model="search" size="small">
                <el-form-item>
                    <el-input v-model.trim="search.kname" clearable placeholder="套餐名称" @keyup.enter="handleSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model.trim="search.code" clearable placeholder="套餐编号" @keyup.enter="handleSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="search.package_type" clearable placeholder="套餐类型" @change="handleSearch">
                        <el-option label="通信+云存储" :value="1"></el-option>
                        <el-option label="纯云存储" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <SearchInnerModel v-model="search.product_model_code" placeholder="选择产品型号"
                        style="width: 220px"></SearchInnerModel>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="search.status" multiple collapse-tags clearable placeholder="套餐状态" @change="handleSearch">
                        <el-option label="测试" :value="0"></el-option>
                        <el-option label="上架" :value="1"></el-option>
                        <el-option label="下架" :value="2"></el-option>
                        <el-option label="已删除" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch">查询</el-button>
                    <el-button @click="resetSearch">重置</el-button>
                </el-form-item>
            </el-form>
            <router-link to="/iot/huntingpack/create">
                <el-button type="primary" size="small">新建套餐</el-button>
            </router-link>
        </div>

        <el-table v-loading="loading" border :data="list" size="small" @sort-change="handleSort">
            <el-table-column prop="name" label="套餐名称" sortable="custom" min-width="140"></el-table-column>
            <el-table-column prop="code" label="套餐编号" min-width="260"></el-table-column>
            <el-table-column label="套餐类型" width="130">
                <template v-slot="scope">{{ packageTypeText(scope.row.package_type) }}</template>
            </el-table-column>
            <el-table-column label="上架区域" min-width="140">
                <template v-slot="scope">{{ (scope.row.regions || []).join(', ') || '未指定' }}</template>
            </el-table-column>
            <el-table-column label="套餐时长" prop="time" sortable="custom" width="120">
                <template v-slot="scope">{{ scope.row.time }} {{ scope.row.time_unit }}</template>
            </el-table-column>
            <el-table-column prop="file_time" label="文件保留(天)" width="120"></el-table-column>
            <el-table-column label="试用套餐" width="90">
                <template v-slot="scope">{{ scope.row.is_trial === 1 ? '是' : '否' }}</template>
            </el-table-column>
            <el-table-column label="标签" width="100">
                <template v-slot="scope">{{ tagText(scope.row.tag) }}</template>
            </el-table-column>
            <el-table-column prop="sort_order" label="排序" sortable="custom" width="80"></el-table-column>
            <el-table-column label="状态" width="120">
                <template v-slot="scope">
                    <el-select :model-value="scope.row.status" size="mini" :disabled="statusLoadingCode === scope.row.code"
                        @change="changeStatus(scope.row, $event)">
                        <el-option label="测试" :value="0"></el-option>
                        <el-option label="上架" :value="1"></el-option>
                        <el-option label="下架" :value="2"></el-option>
                        <el-option label="已删除" :value="3"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120" fixed="right">
                <template v-slot="scope">
                    <router-link :to="'/iot/huntingpack/detail/' + scope.row.code">
                        <el-button type="primary" size="mini">详情</el-button>
                    </router-link>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination v-model:currentPage="search.page" :page-size="search.limit" :total="total"
            layout="total, prev, pager, next" @current-change="loadList"></el-pagination>
    </div>
</template>

<script>
import api from '../../../axios/pack'
import SearchInnerModel from '../../../components/device/SearchInnerModel.vue'

const defaultSearch = () => ({
    page: 1,
    limit: 20,
    kname: '',
    code: '',
    package_type: undefined,
    product_model_code: '',
    status: [0, 1],
    order_field: undefined,
    order_action: 1
})

export default {
    name: 'HuntingPackageList',
    components: {
        SearchInnerModel
    },
    data() {
        return {
            search: defaultSearch(),
            list: [],
            total: 0,
            loading: false,
            statusLoadingCode: ''
        }
    },
    methods: {
        packageTypeText(value) {
            return value === 1 ? '通信+云存储' : value === 2 ? '纯云存储' : '-'
        },
        tagText(value) {
            return value === 'recommended' ? '推荐' : value === 'best_value' ? '最划算' : '-'
        },
        handleSearch() {
            this.search.page = 1
            this.loadList()
        },
        resetSearch() {
            this.search = defaultSearch()
            this.loadList()
        },
        handleSort({ prop, order }) {
            const fieldMap = { name: 'name', time: 'time', sort_order: 'sort_order' }
            this.search.order_field = order ? fieldMap[prop] : undefined
            this.search.order_action = order === 'descending' ? 2 : 1
            this.handleSearch()
        },
        loadList() {
            this.loading = true
            const params = {
                ...this.search,
                kname: this.search.kname || undefined,
                code: this.search.code || undefined,
                product_model_code: this.search.product_model_code || undefined,
                model_action: this.search.product_model_code ? 1 : undefined,
                status: this.search.status.length ? JSON.stringify(this.search.status) : undefined
            }
            api.HuntingPackageList(params).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data.data || []
                    this.total = res.data.data.page_info ? res.data.data.page_info.total : 0
                    return
                }
                this.$message.error('获取失败：' + res.data.msg)
            }).finally(() => {
                this.loading = false
            })
        },
        changeStatus(row, status) {
            const submit = () => {
                this.statusLoadingCode = row.code
                api.HuntingPackageUpdateStatus({ code: row.code, status }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('状态修改成功')
                        this.loadList()
                        return
                    }
                    this.$message.error('状态修改失败：' + res.data.msg)
                }).finally(() => {
                    this.statusLoadingCode = ''
                })
            }
            if (status === 3) {
                this.$confirm('删除后套餐将不可见，确定继续?', '提示', { type: 'warning' }).then(submit).catch(() => {})
                return
            }
            submit()
        }
    },
    created() {
        this.loadList()
    }
}
</script>

<style scoped>
.hunting-search {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
</style>
